export default __webpack_public_path__ + "static/media/dieppe7.065f66f3.jpg";